export default {
      id: "poles-economie-sociale-usage",
      viewBox: "0 0 400 81",
      url: __webpack_public_path__ + "svg/sprite.svg#poles-economie-sociale",
      toString: function () {
        return this.url;
      }
    }